// src/components/Footer.js
import React from "react";
import { Link } from "react-router-dom";
import equal_housing_opportunity_gray from "../assets/equal_housing_opportunity_gray.png";

const Footer = () => {
  return (
    <footer>
      {/* Upper Footer Section */}
      <div className="bg-reading-gray">
        <div className="text-footer-text-main">
          <div className="container mx-auto px-6 py-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12 lg:gap-16 text-center">
              <div>
                <h3 className="text-lg font-semibold text-footer-text-heading mb-4">
                  Reading Tower Apartments
                </h3>
                <p className="text-footer-text-main text-sm leading-relaxed">
                  601 Penn Street
                  <br />
                  Reading, PA 19601{" "}
                  <a
                    href="https://www.google.com/maps/search/?api=1&query=601+Penn+Street,+Reading,+PA+19601"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-footer-text-main hover:text-sky-300 underline transition-colors duration-150"
                  >
                    MAP
                  </a>
                </p>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-footer-text-heading mb-4">
                  Contact us to schedule a tour
                </h3>
                <p className="text-sm font-semibold text-footer-text-main hover:text-sky-300 underline transition-colors duration-150">
                  <a href="tel:+1-877-601-7366">(877) 601-7366</a>
                </p>
                <p className="mt-2 text-sm leading-relaxed">
                  Or email{" "}
                  <a
                    href="mailto:Leasing@Readingtower.com"
                    className="text-footer-text-main hover:text-sky-300 underline transition-colors duration-150"
                  >
                    Leasing@Readingtower.com
                  </a>
                  {" "}or{" "}
                  <Link
                    to="/contact-us"
                    className="text-footer-text-main hover:text-sky-300 underline transition-colors duration-150"
                  >
                    drop us a line!
                  </Link>
                </p>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-footer-text-heading mb-4">
                  Leasing now!
                </h3>
                <Link
                  to="/availability"
                  className="text-sm text-footer-text-main hover:text-sky-300 underline transition-colors duration-150"
                >
                  Apply today
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className=" text-footer-text-copyright">
          <div className="container mx-auto px-6 pb-8">
            {/* UPDATED: Centering content */}
            <div className="flex flex-col md:flex-row items-center justify-center text-center md:space-x-4 space-y-3 md:space-y-0">
              <p className="text-xs">
                © {new Date().getFullYear()} Reading Tower Apartments. All Rights
                Reserved.
              </p>
              <img
                src={equal_housing_opportunity_gray}
                alt="Equal Housing Opportunity"
                className="h-6"
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
